import { Link } from 'react-router-dom'
import clickDePagoMacro from '../../img/clickDePagoMacro.webp';
import QRMacro from '../../img/QRMacro.webp';
import macroPagar from '../../img/macroPagar.webp';
const BancoMacro = () => {
   return (
        // <div className="bg-white animated fadeIn">
        //     <div className="container section">
        //         <div className="row">
        //             <div className="center-vertical">
        //                 <div className="col s12 m12 l4 x4 center">
        //                     <Link to={""}><img src={clickDePagoMacro} className="responsive-img"/></Link>
        //                 </div>
        //                 <div className="col s12 m12 l4 x4 center">
        //                     <Link to={""}><img src={QRMacro} width="75%" height="75%" className="responsive-img"/></Link>
        //                 </div>
        //                 <div className="col s12  m12 l4  x4 center text-color-latitud">
        //                     <img src={macroPagar} className="responsive-img"/>
        //                     <Link to={"/pagopoliza"} className="btn btn-large waves-effect waves-light light-blue accent-3  white pulse" type="submit">Pagar Póliza
        //                         <i className="material-icons right">send</i>
        //                     </Link>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
      <div className="section animated fadeIn" style={{ margin: '30px 0', padding: 0 }}>
         {/* TARJETA CONTENEDORA CORPORATIVA */}
         <div className="card-panel bg-latitud z-depth-2" style={{ borderRadius: '12px', padding: '45px 30px', backgroundColor: '#039be5', margin: 0 }}>
            <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', margin: 0, maxWidth: '1400px', marginLeft: 'auto', marginRight: 'auto' }}>
               {/* 1. CLICK DE PAGO MACRO */}
               <div className="col s12 m12 l4 x4 center-align" style={{ marginBottom: '20px' }}>
                  <div style={{ background: 'rgba(255, 255, 255, 0.95)', padding: '20px 25px', borderRadius: '10px', display: 'inline-block', boxShadow: '0 4px 15px rgba(0,0,0,0.15)' }}>
                     <Link to="">
                        <img src={clickDePagoMacro} alt="Click de Pago Macro" className="responsive-img" style={{ maxHeight: '90px', objectFit: 'contain', display: 'block', margin: '0 auto' }} />
                     </Link>
                  </div>
               </div>
               {/* 2. QR MACRO (AHORA MUCHO MÁS GRANDE) */}
               <div className="col s12 m12 l4 x4 center-align" style={{ marginBottom: '20px' }}>
                  <div style={{ background: 'rgba(255, 255, 255, 0.95)', padding: '15px 20px', borderRadius: '10px', display: 'inline-block', boxShadow: '0 4px 15px rgba(0,0,0,0.15)' }}>
                     <Link to="">
                        <img src={QRMacro} alt="QR Macro" className="responsive-img" style={{ maxHeight: '200px', objectFit: 'contain', display: 'block', margin: '0 auto' }} />
                     </Link>
                  </div>
               </div>
               {/* 3. MACRO PAGAR Y BOTÓN DE PAGO */}
               <div className="col s12 m12 l4 x4 center-align" style={{ marginBottom: '20px' }}>
                  <div style={{ background: 'rgba(255, 255, 255, 0.95)', padding: '20px 25px', borderRadius: '10px', display: 'inline-block', boxShadow: '0 4px 15px rgba(0,0,0,0.15)', width: '100%', maxWidth: '320px' }}>
                     <img src={macroPagar} alt="Macro Pagar" className="responsive-img" style={{ maxHeight: '120px', objectFit: 'contain', marginBottom: '18px', display: 'block', margin: '0 auto 18px auto' }} />
                     <Link 
                        to={"/pagopoliza"} 
                        className="btn waves-effect waves-light light-blue accent-3 z-depth-0" 
                        style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', width: '100%', height: '44px', lineHeight: '44px', fontSize: '1.05rem' }}
                     >
                        Pagar Póliza
                        <i className="material-icons right" style={{ fontSize: '1.2rem' }}>payment</i>
                     </Link>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default BancoMacro